import { Link } from "react-router-dom";
import { ShieldCheck, Eye, Lock, Server, ArrowLeft } from "lucide-react";

export default function TestSecurityServices() {
    return (
        <main className="min-h-screen bg-gradient-to-b from-indigo-700 via-indigo-600 to-violet-600 px-6 py-12 flex justify-center">
            <div className="w-full max-w-5xl bg-white rounded-2xl shadow-xl p-8">
                <div className="flex items-center gap-3 mb-6">
                    <img src="/Images/ExamsPro.png" alt="ExamsPro" className="w-10 h-10" />
                    <h1 className="text-2xl font-bold text-indigo-700">
                        Test Security Services
                    </h1>
                </div>

                <p className="text-gray-600 mb-8 leading-relaxed">
                    Protect your exams before, during, and after delivery with proactive
                    monitoring, data encryption, and forensic analysis tools.
                </p>

                <section className="grid md:grid-cols-2 gap-6">
                    <div className="rounded-xl border border-indigo-100 p-6 hover:shadow-md transition">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <ShieldCheck className="w-5 h-5" />
                            <h3 className="font-semibold">Exam Security Audits</h3>
                        </div>
                        <ul className="text-gray-700 space-y-2 text-sm">
                            <li>� End-to-end encryption verification</li>
                            <li>� Access control and RLS testing</li>
                            <li>� Security compliance documentation</li>
                        </ul>
                    </div>

                    <div className="rounded-xl border border-indigo-100 p-6 hover:shadow-md transition">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <Eye className="w-5 h-5" />
                            <h3 className="font-semibold">Proctoring Oversight</h3>
                        </div>
                        <ul className="text-gray-700 space-y-2 text-sm">
                            <li>� Monitor live/recorded exams</li>
                            <li>� Detect anomalies & unauthorized devices</li>
                            <li>� Escalate with real-time alerts</li>
                        </ul>
                    </div>

                    <div className="rounded-xl border border-indigo-100 p-6 hover:shadow-md transition">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <Lock className="w-5 h-5" />
                            <h3 className="font-semibold">Data Protection</h3>
                        </div>
                        <ul className="text-gray-700 space-y-2 text-sm">
                            <li>� AES-256 & TLS 1.3 encryption</li>
                            <li>� Role-based permissions & audit logs</li>
                            <li>� Secure content storage & retrieval</li>
                        </ul>
                    </div>

                    <div className="rounded-xl border border-indigo-100 p-6 hover:shadow-md transition">
                        <div className="flex items-center gap-2 mb-3 text-indigo-700">
                            <Server className="w-5 h-5" />
                            <h3 className="font-semibold">Forensic Analytics</h3>
                        </div>
                        <ul className="text-gray-700 space-y-2 text-sm">
                            <li>� Answer pattern & timing analysis</li>
                            <li>� Suspicious behavior detection</li>
                            <li>� Post-test integrity reporting</li>
                        </ul>
                    </div>
                </section>

                <div className="mt-10 flex flex-wrap justify-center gap-4">
                    <Link
                        to="/contact"
                        className="inline-flex items-center justify-center bg-indigo-600 text-white px-5 py-2.5 rounded-full font-semibold hover:bg-indigo-700 transition shadow-sm"
                    >
                        Request Security Audit
                    </Link>

                    <Link
                        to="/solutions/examspro"
                        className="inline-flex items-center gap-2 bg-indigo-100 text-indigo-700 hover:bg-indigo-200 px-5 py-2.5 rounded-full font-semibold transition shadow-sm"
                    >
                        <ArrowLeft className="w-4 h-4" />
                        Back to ExamsPro
                    </Link>
                </div>
            </div>
        </main>
    );
}
